import {
  ChangeDetectionStrategy,
  Component,
  computed,
  inject,
  signal,
} from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { firstValueFrom } from "rxjs";
import { ApiService, SupplierEstimateSummary } from "../core/api.service";
import { OrderKind, filterByKind } from "../core/orders.util";
import { OrdersListComponent } from "./orders-list.component";

@Component({
  selector: "app-orders-page",
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [OrdersListComponent],
  templateUrl: "./orders-page.component.html",
})
export class OrdersPageComponent {
  private readonly api = inject(ApiService);
  private readonly route = inject(ActivatedRoute);

  private readonly kind = this.route.snapshot.data["kind"] as OrderKind;
  readonly title = this.route.snapshot.data["title"] as string;
  readonly emptyMessage = this.route.snapshot.data["emptyMessage"] as string;

  private readonly estimates = signal<SupplierEstimateSummary[]>([]);
  readonly loading = signal(true);
  readonly error = signal<string | null>(null);

  readonly orders = computed(() => filterByKind(this.estimates(), this.kind));

  constructor() {
    void this.load();
  }

  async load() {
    this.loading.set(true);
    this.error.set(null);
    try {
      const list = await firstValueFrom(this.api.myEstimates());
      this.estimates.set(list);
    } catch {
      this.error.set("Failed to load your orders. Please try again.");
    } finally {
      this.loading.set(false);
    }
  }
}
